import React from "react";
import { LightboxControllerButton } from "./lightbox-controller-button";

/** Props Interface */
interface LightboxControllerProps {
	focusPreviousItem: () => void;
	focusNextItem: () => void;
}

export function LightboxController({ focusPreviousItem, focusNextItem }: LightboxControllerProps) {
	/** Render */
	return (
		<React.Fragment>
			<LightboxControllerButton
				direction="previous"
				onClick={focusPreviousItem}
			/>
			<LightboxControllerButton
				direction="next"
				onClick={focusNextItem}
			/>
		</React.Fragment>
	);
}
